export default __webpack_public_path__ + "static/145-min-min-a0415c3881c1778535c26060120c4891.jpg";